var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ShogiPlayer',_vm._g(_vm._b({},'ShogiPlayer',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }